import { useCallback } from 'react';
import { PdfFile } from '@/components/Icons.tsx';

export type Attachment = {
  fileId: number;
  name: string;
  resource: {
    resourceUrl: string;
  }
};

const DownloadPdfButton = ({ file }: { file: Attachment }) => {
  const downloadFile = useCallback(async () => {
    const source = await fetch(file.resource.resourceUrl);
    const blob = await source.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${file.name}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, [file]);

  return (
    <button
      className="flex items-center justify-start gap-4 rounded border border-shade-10 px-3 py-1.5 hover:bg-shade-5"
      onClick={downloadFile}
    >
      <PdfFile className="w-8 h-8 text-neutral2-icon" />
      <span className="flex flex-col items-start text-left">
        <span className="text-neutral2-text-strong text-body font-normal line-clamp-1">{file.name}</span>
        <span className="text-caption text-primary">Download</span>
      </span>
    </button>
  );
};

export default DownloadPdfButton;
